import React, {useState} from 'react'
import {GridAddIcon} from '@mui/x-data-grid'
import {StyledLink} from '../Link/components'
import theme from '../../../theme/theme'

export interface AddCommentProps {
  onClick: () => void,
}

function AddComment({onClick}: AddCommentProps) {
  const [isCommentBoxOpen, setCommentBoxOpen] = useState(false)

  const handleClick = () => {
    setCommentBoxOpen(prevState => !prevState)
    onClick()
  }

  return (
    <StyledLink
      style={{
        textDecoration: 'none',
        color: theme.palette.primary.main,
        display: 'flex',
        alignItems: 'center',
        marginTop: '16px',
        cursor: 'pointer'
      }}
      onClick={handleClick}
    >
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'transform 0.3s linear',
        transform: isCommentBoxOpen ? 'rotate(45deg)' : 'rotate(0deg)'
      }}
      >
        <GridAddIcon style={{fontSize: '24px'}} />
      </div>
      Add Comment
    </StyledLink>
  )
}

export default AddComment